<div fxLayout="row" fxFlex="100%" fxLayoutAlign="space-between center">
    <mat-icon >warning</mat-icon>
    <strong >
         <b>{{Message}}</b>
    </strong>
    <mat-icon fxFlex (click)="closeToastNotification()" >close</mat-icon>
</div>
